'use client';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import React from 'react';
import { toast } from 'sonner';

const CopyButton = ({ text }: { text: string }) => {
  return (
    <CopyToClipboard text={text}>
      <Button
        size="icon"
        variant="ghost"
        className="rounded-full h-8 w-8"
        onClick={() =>
          toast.success('复制成功', {
            position: 'top-center',
          })
        }
      >
        <Copy size={16} className="w-4 h-4" />
      </Button>
    </CopyToClipboard>
  );
};

export default CopyButton;
